module.exports = __webpack_public_path__ + "static/media/earthmed-site-logo-bigger.deb4b8c4.png";